<template>
  <!-- vista alterna  -->
  <section class="invoice-preview-wrapper">
    <b-overlay
      :show="showLoader"
      opacity="0.50"
      rounded="sm"
    >
      <b-row
        v-if="!isEmptyObject(datrefe)"
        class="invoice-preview"
      >
        <!-- Col: Left (container orden) -->
        <b-col
          v-if="!isEmptyObject(datrefe.info)"
          cols="12"
          xl="9"
          md="8"
        >
          <b-card
            no-body
            class="invoice-preview-card"
          >
            <!-- Header -->
            <b-card-body class="invoice-padding pb-0">

              <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                <!-- Header: Left Content -->
                <div>
                  <div class="logo-wrapper">
                    <logo />
                    <h3 class="text-primary invoice-logo">
                      {{ (isEmptyObject(datrefe.alumno)) ? 'Inscripción a Campus' : 'Aportación a Cuatrimestre' }}
                    </h3>
                  </div>
                  <p class="card-text mb-25">
                    Calle Paseo del Alba No. 1276, Esquina Con Av. Gral. Ramón Corona, Col. Solares Residencial C.P. 45019
                  </p>
                  <p class="card-text mb-25">
                    Zapopan, Jalisco. México.
                  </p>
                  <p class="card-text mb-0">
                    33-3669-5550 al 5559
                  </p>
                </div>

                <!-- Header: Right Content -->
                <div class="mt-md-0 mt-2">
                  <h4
                    id="cmp-solicitud"
                    class="invoice-title"
                  >
                    <span class="invoice-number">#{{ datrefe.info.id }}</span>
                  </h4>
                  <div class="invoice-date-wrapper">
                    <p class="invoice-date-title">
                      Registrada:
                    </p>
                    <p class="invoice-date">
                      {{ datrefe.info.fecha }}
                    </p>
                  </div>
                  <div class="invoice-date-wrapper">
                    <p class="invoice-date-title">
                      Status:
                    </p>
                    <p class="invoice-date">
                      <b-badge :variant="frmstatus(datrefe.info.status).color">
                        {{ frmstatus(datrefe.info.status).text }}
                      </b-badge>
                    </p>
                  </div>
                </div>
              </div>
            </b-card-body>
            <!-- Spacer -->
            <hr class="invoice-spacing">
            <!-- Invoice Client & Payment Details -->
            <b-card-body
              v-if="datrefe.alumno"
              class="invoice-padding pt-0"
            >
              <b-row class="invoice-spacing">
                <!-- Col: alumno or registro -->
                <b-col
                  v-if="!isEmptyObject(datrefe.alumno)"
                  cols="12"
                  xl="6"
                  class="p-0"
                >
                  <h6 class="mb-25">
                    {{ datrefe.alumno.nombreCompleto }}
                  </h6>
                  <p class="card-text mb-25">
                    {{ datrefe.alumno.email }}
                  </p>
                  <p class="card-text mb-25">
                    Mtrl: {{ datrefe.info.matricula }}
                  </p>
                  <p class="card-text mb-25">
                    (01) {{ datrefe.alumno.telefono1 }}
                  </p>
                  <p class="card-text mb-0">
                    {{ datrefe.alumno.emailAlt }}
                  </p>
                  <p
                    v-show="datrefe.info.desc_beca"
                    class="card-text mb-0 pt-1"
                  ><b-badge
                    variant="primary"
                    class="badge-glow"
                  >
                    {{ datrefe.info.desc_beca }}
                  </b-badge>
                  </p>
                </b-col>
                <b-col
                  v-if="!isEmptyObject(datrefe.registro)"
                  cols="12"
                  xl="6"
                  class="p-0"
                >
                  <h6 class="mb-25">
                    {{ datrefe.registro.fullname }}
                  </h6>
                  <p class="card-text mb-25">
                    {{ datrefe.registro.email }}
                  </p>
                  <p class="card-text mb-25">
                    {{ datrefe.registro.telefono }}
                  </p>
                  <p class="card-text mb-25">
                    {{ datrefe.registro.strEntidadFed }}
                  </p>
                  <p class="card-text mb-25">
                    {{ datrefe.registro.strDependencia }}
                  </p>
                  <p
                    v-show="datrefe.registro.strbeca"
                    class="card-text mb-0 pt-1"
                  ><b-badge
                    variant="primary"
                    class="badge-glow"
                  >
                    {{ datrefe.registro.strbeca }}
                  </b-badge>
                  </p>
                </b-col>
                <!-- Datos para pagar -->
                <b-col
                  xl="6"
                  cols="12"
                  class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end"
                >
                  <div id="cmp-referencia">
                    <h6 class="mb-2">
                      Detalles para depósito:
                    </h6>
                    <table>
                      <tbody>
                        <tr>
                          <td class="pr-1">
                            Limite de Pago:
                          </td>
                          <td>
                            <b-badge
                              :variant="(datrefe.info.limitePago) ? 'light-danger' : '' "
                              class="badge-glow"
                            >
                              {{ (datrefe.info.limitePago) ? datrefe.info.limitePago : '-' }} </b-badge></td>
                        </tr>
                        <tr>
                          <td class="pr-1">
                            Referencia:
                          </td>
                          <td><b-badge
                            :variant="(datrefe.info.referencia) ? 'light-dark' : '' "
                            class="badge-glow"
                          >
                            {{ (datrefe.info.referencia) ? datrefe.info.referencia : '-' }} </b-badge></td>
                        </tr>
                        <tr>
                          <td class="pr-1">
                            Transacción Válida:
                          </td>
                          <td><b>{{ (!isEmptyObject(datrefe.pagovalido) ) ? '# '+datrefe.pagovalido.transaccion : '-' }}</b></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
            <!-- detalle de orden or Mensaje de Inscripcion -->
            <b-table-lite
              v-show="(datrefe.resumen.length > 0)"
              responsive
              :items="datrefe.resumen"
              :fields="['nombre', 'periodo', 'clave', 'modalidad']"
              show-empty
            >
              <template #empty="scope">
                Sin resultados - {{ scope.emptyText }}
              </template>
              <template #cell(modalidad)="data">
                <b-card-text class="font-weight-bold mb-25">
                  {{ nombreModalidad(data.item.modalidad) }}
                </b-card-text>
              </template>
            </b-table-lite>
            <b-alert
              v-show="isEmptyObject(datrefe.alumno)"
              variant="dark"
              class="m-2"
              show
            >
              <h4 class="alert-heading">
                Ésta solicitud cubrirá la inscripción a
              </h4>
              <div class="alert-body">
                <span>{{ datrefe.registro.strPlanStudios }}</span>
              </div>
            </b-alert>
            <!-- Pago valido -->
            <b-table-lite
              v-if="!isEmptyObject(datrefe.pagovalido)"
              responsive
              :items="itemsTransValid"
              :fields="fieldsValidtran"
            >
              <template #cell(fecha_pago)="data">
                <b-card-text class="font-weight-bold mb-25">
                  {{ data.item.fecha_pago }}
                </b-card-text>
              </template>
              <template #cell(precioFinal)="data">
                <b-card-text class="font-weight-bold mb-25">
                  $ {{ data.item.precioFinal }} mxn.
                </b-card-text>
              </template>
            </b-table-lite>

            <!-- Factura pago valido -->
            <b-card-body
              v-if="!isEmptyObject(datrefe.pagovalido)"
              class="invoice-padding pt-0"
            >
              <b-row
                v-show="datrefe.pagovalido.factura"
                class="invoice-spacing"
              >
                <!-- Col: Invoice To -->
                <b-col
                  cols="12"
                  xl="6"
                  class="p-0"
                >
                  <h6 class="mb-2">
                    Factura:
                  </h6>
                  <p class="card-text mb-25">
                    CFDI: {{ datrefe.pagovalido.cfdi }}
                  </p>
                  <p class="card-text mb-25">
                    Correo 1: {{ datrefe.pagovalido.correo1 }}
                  </p>
                  <p class="card-text mb-25">
                    Correo 2: {{ datrefe.pagovalido.correo2 }}
                  </p>
                  <p class="card-text mb-25">
                    Razón S.: {{ datrefe.pagovalido.razon }}
                  </p>
                  <p class="card-text mb-0">
                    RFC: {{ datrefe.pagovalido.rfc }}
                  </p>
                </b-col>
                <!-- Col: Payment Details -->
                <b-col
                  xl="6"
                  cols="12"
                  class="p-0 mt-xl-0 d-flex justify-content-xl-end"
                >
                  <div>
                    <h6 class="mb-2">
                      Dirección:
                    </h6>
                    <table>
                      <tbody>
                        <tr>
                          <td class="pr-1">
                            Calle:
                          </td>
                          <td>{{ datrefe.pagovalido.calle }}, {{ (datrefe.pagovalido.interior) ? 'int: '+datrefe.pagovalido.interior+',' : '' }} ext: {{ datrefe.pagovalido.numero }}  </td>
                        </tr>
                        <tr>
                          <td class="pr-1">
                            Colonia:
                          </td>
                          <td>{{ datrefe.pagovalido.colonia }}, {{ datrefe.pagovalido.cp }}</td>
                        </tr>
                        <tr>
                          <td class="pr-1">
                            Referencias
                          </td>
                          <td><b>{{ (datrefe.pagovalido.ref1) ? datrefe.pagovalido.ref1 : 'N/A' }}</b></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>

            <!-- Invoice Description: Total -->
            <b-card-body class="invoice-padding pb-0">
              <b-row>
                <!-- Col: Sales Persion -->
                <b-col
                  cols="12"
                  md="4"
                  class="mt-md-0 mt-3"
                  order="2"
                  order-md="1"
                />

                <!-- Col: Total -->
                <b-col
                  v-show="!isEmptyObject(datrefe.info)"
                  cols="12"
                  md="8"
                  class="mt-md-6 d-flex justify-content-end"
                  order="1"
                  order-md="2"
                >
                  <div class="invoice-total-wrapper">
                    <!-- cupon aplicado -->
                    <div v-show="datrefe.info.codigo">
                      <div class="invoice-total-item">
                        <p class="invoice-total-title">
                          Código:
                        </p>
                        <p class="invoice-total-amount">
                          {{ datrefe.info.codigo }}
                        </p>
                      </div>
                      <div class="invoice-total-item">
                        <p class="invoice-total-title">
                          Descuento:
                        </p>
                        <p class="invoice-total-amount">
                          {{ datrefe.info.descuento }} %
                        </p>
                      </div>
                      <hr class="my-50">
                    </div>
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">
                        Aportación:
                      </p>
                      <p
                        id="cmp-aportacion"
                        class="invoice-total-amount"
                      >
                        {{ (datrefe.info.status == 'ACT' && datrefe.info.fprecioFinal == 0) ? 'Pendiente' : '$ '+datrefe.info.fprecioFinal }}
                      </p>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>

            <!-- Spacer -->
            <hr class="invoice-spacing">

            <!-- Observaciones -->
            <b-card-body class="invoice-padding pt-0">
              <span class="font-weight-bold">Observaciones: </span>
              <span>{{ datrefe.info.observaciones }}</span>
            </b-card-body>
          </b-card>
        </b-col>

        <!-- Right Col: Card -->
        <b-col
          v-if="!isEmptyObject(datrefe.info) && datrefe.info.status == 'ACT' && getRol.id != 5"
          cols="12"
          md="4"
          xl="3"
          class="invoice-actions"
        >
          <b-card>
            <b-button
              v-show="getRol.id == 1 && frompublic === true && isEmptyObject(datrefe.alumno)"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="info"
              class="mb-2"
              @click="tourStart"
            >
              Indicaciones de primer Ingreso
            </b-button>
            <!-- imprimir orden -->
            <b-button
              class="mb-75"
              block
              @click="printInvoice"
            >
              <feather-icon
                icon="PrinterIcon"
                class="mr-50"
              />
              <span class="align-middle">Imprimir</span>
            </b-button>
            <!-- Config datosFacturacion -->
            <b-button
              v-show="getRol.id == 1 && frompublic === true && isEmptyObject(datrefe.alumno)"
              id="btn-df"
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="outline-success"
              class="mb-75"
              block
              :to="`/compras/df/inscripcion/${$route.params.id}/${datrefe.persona.id}`"
            >
              <feather-icon
                icon="ToolIcon"
                class="mr-50"
              />
              <span class="align-middle">Datos de Facturación</span>
            </b-button>
            <!-- transacciones alumno -->
            <!-- go|tran /compras/transaccion/inscripcion-->
            <b-button
              v-show="!frompublic"
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              class="mb-75"
              block
              :to="`/compras/${(userRol.id != 1) ? 'ordenes/transaccion' : 'transaccion'}/${$route.params.id}/`"
            >
              <feather-icon
                icon="ShoppingBagIcon"
                class="mr-50"
              />
              <span class="align-middle">Transacciones</span>
            </b-button>
            <!-- transacciones publicas -->
            <b-button
              v-show="frompublic"
              id="btn-tran"
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              class="mb-75"
              block
              :to="`/compras/transaccion/inscripcion/${$route.params.id}/`"
            >
              <feather-icon
                icon="ShoppingBagIcon"
                class="mr-50"
              />
              <span class="align-middle">Transacciones</span>
            </b-button>
            <!-- Solicitar pre-factura -->
            <b-button
              v-show="!isEmptyObject(datrefe.persona) && getRol.id == 1"
              id="btn-prefac"
              class="bg-warning bg-lighten-4 mb-75"
              block
              @click="shallShowEmailComposeModal = true"
            >
              <feather-icon
                icon="MessageSquareIcon"
                class="mr-50"
              />
              <span class="align-middle">Pre-Factura</span>
            </b-button>
            <!-- Configurar datos de facturacion -->
            <b-button
              v-show="getRol.id != 1 && frompublic === false && !isEmptyObject(datrefe.registro)"
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="outline-info"
              class="mb-75"
              block
              @click="configDF(datrefe.persona)"
            >
              <feather-icon
                icon="ToolIcon"
                class="mr-50"
              />
              <span class="align-middle">Datos de Facturación</span>
            </b-button>
            <b-alert
              v-show="getRol.id == 1 && frompublic === false"
              variant="success"
              show
            >
              <h4 class="alert-heading">
                Atención
              </h4>
              <div class="alert-body">
                <span><b>Si requiere factura</b> es importante que configure antes los <b>Datos de Facturación</b>. puede acceder en el siguiente link.</span><br>
                <span class="mt-2 text-center"><b-link to="/cuenta/">Configurar</b-link></span>
              </div>
            </b-alert>
          </b-card>
        </b-col>
        <b-col
          v-if="!isEmptyObject(datrefe.info) && getRol.id == 5"
          cols="12"
          md="4"
          xl="3"
          class="invoice-actions"
        >
          <b-card>
            <!-- imprimir orden -->
            <b-button
              class="mb-75"
              block
              @click="printInvoice"
            >
              <feather-icon
                icon="PrinterIcon"
                class="mr-50"
              />
              <span class="align-middle">Imprimir</span>
            </b-button>
          </b-card>

        </b-col>
      </b-row>
      <b-row
        v-show="isEmptyObject(datrefe.info)"
        class="invoice-preview"
      >
        <b-alert
          variant="primary"
          show
        >
          <h4 class="alert-heading">
            ¡Ups! no se encontro información de la solicitud en este link.
          </h4>
          <div class="alert-body">
            No te preocupes contacta con nosotros y envia este link a soporte para su revisión. Ahora puedes cerrar esta ventana o regresar a un lugar seguro
            <b-link
              class="alert-link"
              :to="(isEmptyObject(userRol) ? '/' : userRol.base_path )"
            >
              ( ir )
            </b-link>
            que tenga buen dia!
          </div>
        </b-alert>
      </b-row>
    </b-overlay>
    <!-- Compose Email Modal -->
    <email-compose
      v-model="shallShowEmailComposeModal"
      :extra-data="{ matricula: (datrefe.info.matricula == null) ? false : true, orden: idOrden }"
      :data-request="dataRequestCompose"
    />
    <!-- pasos a seguir -->
    <app-tour :steps="stepsPublicUpload" />
  </section>
</template>

<script>
import {
  ref, onMounted,
} from '@vue/composition-api'
import store from '@/store'

import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  VBToggle,
  BBadge,
  BOverlay,
} from 'bootstrap-vue'
import AppTour from '@core/components/app-tour/AppTour.vue'
import {
  useRouter, isEmptyObject, isObject, formhttp,
} from '@core/utils/utils'
import Logo from '@core/layouts/components/Logo.vue'
import Ripple from 'vue-ripple-directive'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { rolesActions } from '@core/mixins/account-data/roles'
import {
  nombreModalidad, frmstatus, formTransac,
} from '@core/utils/filter'
import hostname from '@core/utils/http/config-hostname'
import EmailCompose from '@core/components/email-compose/EmailCompose.vue'
import { ordenInfo } from '../useCompras'
import { HelpVTour } from '../../ayuda/useAyudaTour'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    Logo,
    BBadge,
    AppTour,
    EmailCompose,
    BOverlay,
  },
  mixins: [rolesActions],
  props: {
    frompublic: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      lfsp: false,
      lbltitulo: '',
    }
  },
  computed: {
    getRol() {
      if (isEmptyObject(this.$store.getters['cuenta/rolCurrent'])) {
        return ({
          id: 1,
          nombre: 'Alumno',
          base_path: '/alumno/dashboard',
        })
      } return this.$store.getters['cuenta/rolCurrent']
    },
  },
  methods: {
    tourStart() {
      this.$tours.vuexyTour.start()
    },
    configDF() {
      const config = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes,width=700,height=800'
      const routeData = `${hostname().host}/app/compras/df/inscripcion/${this.datrefe.info.id}/${this.datrefe.persona.id}`
      window.open(routeData, 'Configurar Facturacion', config)
    },
  },
  setup() {
    const showLoader = ref(false)
    const toast = useToast()
    const paymentDetails = ref({})
    const datrefe = ref({
      status: null,
      message: null,
      info: {},
      persona: null,
      resumen: null,
      registro: null,
      plan: null,
      pagovalido: null,
      alumno: null,
    })
    const { route } = useRouter()
    const fieldsValidtran = ref({})
    // config mail
    const shallShowEmailComposeModal = ref(false)
    const personSelected = ref(null)
    const itemsTransValid = ref([])
    // modulo que funciona publicamente y dentro del sistema
    const dataRequestCompose = { action: 21, task: 'wscompras' }

    if (isEmptyObject(store.state.cuenta.session)) {
      dataRequestCompose.action = 24
      dataRequestCompose.task = 'wsinscripcion'
    }

    const classmates = ref([])
    fieldsValidtran.value = [
      {
        key: 'fecha_pago',
        label: 'Registrado',
      },
      {
        key: 'precioFinal',
        label: 'Aportación',
      },
      {
        key: 'frmpago',
        label: 'Forma Pago',
      },
      {
        key: 'comentarios',
      },
    ]
    const idOrden = (route.value.params.id) ? window.atob(route.value.params.id) : 0

    const printInvoice = () => {
      window.print()
    }
    // Load info about orden
    const loadReferenciaData = () => {
      showLoader.value = true
      ordenInfo(idOrden).then(response => {
        const { icon, label } = formhttp(response.status)
        datrefe.value = response
        // solo para listar la tabla de pago valido
        itemsTransValid.value = [response.pagovalido]
        toast({
          component: ToastificationContent,
          props: {
            title: 'Preparando Información',
            text: response.message,
            icon,
            variant: label,
          },
        })
        showLoader.value = false
      }, error => {
        showLoader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Información de Orden]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 9000 })
      })
    }

    // tomo lo de vtour
    const {
      stepsPublicUpload,
    } = HelpVTour()
    // buscando info de la orden
    onMounted(
      () => {
        if (idOrden) loadReferenciaData()
      },
    )

    return {
      paymentDetails,
      printInvoice,
      // loadData,
      datrefe,
      fieldsValidtran,
      loadReferenciaData,
      nombreModalidad,
      frmstatus,
      // flags
      showLoader,
      shallShowEmailComposeModal,
      personSelected,
      dataRequestCompose,
      classmates,
      formTransac,
      // arrays for tables
      itemsTransValid,
      stepsPublicUpload,
      // tools
      isEmptyObject,
      isObject,
      idOrden,
    }
  },
}
</script>

<style lang="scss" scoped>
  @import "~@core/scss/base/pages/app-invoice.scss";
  @import '@core/scss/vue/libs/tour.scss';
</style>

<style lang="scss">
  @media print {
    // Global Styles
    body {
      background-color: transparent !important;
    }
    nav.header-navbar {
      display: none;
    }
    .main-menu {
      display: none;
    }
    .header-navbar-shadow {
      display: none !important;
    }
    .content.app-content {
      margin-left: 0;
      padding-top: 2rem !important;
    }
    footer.footer {
      display: none;
    }
    .card {
      background-color: transparent;
      box-shadow: none;
    }
    .customizer-toggle {
      display: none !important;
    }
    // Invoice Specific Styles
    .invoice-preview-wrapper {
      .row.invoice-preview {
        .col-md-8 {
          max-width: 100%;
          flex-grow: 1;
        }

        .invoice-preview-card {
          .card-body:nth-of-type(2) {
            .row {
                > .col-12 {
                max-width: 50% !important;
              }

              .col-12:nth-child(2) {
                display: flex;
                align-items: flex-start;
                justify-content: flex-end;
                margin-top: 0 !important;
              }
            }
          }
        }
      }

      // Action Right Col
      .invoice-actions {
        display: none;
      }
    }
  }
</style>
